import type { IColumnRawInfo, TFieldType } from '@dbl/core/dataSource';
import { FieldType } from '@dbl/core/dataSource';

import { normalizeTableCycleToLegalGranularity } from './transformers';
import type { IGetTableInfoDto, ITableColumnDto } from './types';

/** QB 转换入参：wire 列 + 可选 enrich 字段（非 Dto 扩展）。 */
export type TTableColumnForQbConversion = ITableColumnDto & {
  isCommonDimension?: boolean;
};

/**
 * ITableColumnDto + IGetTableInfoDto → IColumnRawInfo（选表加入 QB 时的初始字段快照）。
 *
 * 自 `core/dataSource/utils` 迁入 services 边界，避免 core 依赖 wire 表结构。
 */
export const convertTableColumnToColumnRawInfo = (
  tableColumn: TTableColumnForQbConversion,
  tableInfo: IGetTableInfoDto,
  index: number,
): IColumnRawInfo & {
  column_open: boolean;
  options_now: [];
  options_all: [];
  isCommonDimension?: boolean;
  is_dimension?: boolean;
  is_metric?: boolean;
  attribute?: number;
  accuracy?: number;
  flag?: number;
  dimension_setting: string;
  date_format?: string;
  to_date_format?: string;
  isAll: boolean;
} => ({
  id: `${tableInfo.table_id}.${tableColumn.name}`,
  table_id: tableInfo.table_id || '',
  table_code: tableInfo?.table_code || `t${index}`,
  column_name: tableColumn.name ?? '',
  column_display: tableColumn.display_name,
  column_display_en: tableColumn.display_name_en,
  column_remark: tableColumn?.remark || tableColumn?.remark_en || '',
  column_remark_en: tableColumn?.remark_en || tableColumn?.remark || '',
  column_type: (tableColumn.type ?? FieldType.String) as TFieldType,
  column_sensitive: Boolean(tableColumn.is_sensitive),
  // cycle 是更新周期，可能含「实时」等非法值；写入筛选粒度前先归一
  column_granularity: normalizeTableCycleToLegalGranularity(tableInfo?.cycle),
  column_open: false,
  options_now: [],
  options_all: [],
  isCommonDimension: tableColumn.isCommonDimension,
  is_dimension: tableColumn.is_dimension,
  is_metric: tableColumn.is_metric,
  attribute: tableColumn.attribute,
  accuracy: tableColumn.accuracy,
  flag: tableColumn.flag,
  dimension_setting: tableColumn.dimension_setting || 'origin',
  date_format: tableColumn.date_format,
  to_date_format: tableColumn.to_date_format,
  isAll: tableColumn.type !== 'date',
});
